import React from "react";
import { withImageResizer } from "lib/utils";
import DateIcon from "../Icons/DateIcon";
import Link from "next/link";
import LocationIcon from "../Icons/LocationIcon";
import PlayIcon from "../Icons/PlayIcon";
import ArrowRight from "../Icons/ArrowRight";
import { format, isFuture } from "date-fns";
import ClockIcon from "../Icons/ClockIcon";

const CarouselItem = ({
  position,
  itemData,
  isLive = false,
  upcomingEvent,
}) => {
  const createItem = ({ position, itemData }) => {
    const item = {
      styles: {},
      data: {
        ...itemData,
        upcomingEvent: "",
      },
    };
    switch (position) {
      case position - 1:
      case position + 1:
        item.styles = {
          ...item.styles,
        };
        break;
      case position:
        break;
      default:
        item.styles = { ...item.styles, ...{ display: "none" } };
        break;
    }
    item.data.upcomingEvent = isFuture(new Date(itemData?.publishingDate));
    return item;
  };
  const item = createItem({ position, itemData });

  return (
    <li className="group transition-all duration-200 ease-linear delay">
      <Link
        href={`/?eventSlug=${item?.data?.urlName}&accountSlug=${item?.data?.account?.urlName}`}
        as={`/kirkko/${item?.data?.account?.urlName}/${item?.data?.urlName}`}
      >
        <a className="w-full">
          <div
            key={item?.data?.title}
            style={item?.styles}
            className="mx-1 rounded-lg transition-all duration-150 ease-linear delay group-hover:scale-110 group-hover:shadow-item"
          >
            {isLive && (
              <div className="relative">
                <div className="absolute h-full bg-blackGradient rounded-10 max-w-full w-full h-236 desktop:h-179 transition-all duration-200 ease-linear delay group-hover:rounded-br-none group-hover:rounded-bl-none flex items-center">
                  <div className="font-bold text-red right-0 top-2 absolute min-w-frontBannerSmallImg flex items-center mr-4">
                    Lähetys menossa
                    <div className="bg-red rounded-full max-w-redDot w-full h-16 ml-2"></div>
                  </div>
                </div>
              </div>
            )}
            <img
              role="img"
              alt={"Kuva" + item?.data?.title}
              className="rounded-10 bg-gray-100 max-w-full w-full h-236 desktop:!h-179 object-cover object-bottom transition-all duration-200 ease-linear delay group-hover:rounded-br-none group-hover:rounded-bl-none"
              src={
                item?.data?.previewImg
                  ? withImageResizer(item?.data?.previewImg, 640)
                  : "/images/bg1.jpeg"
              }
            ></img>
            <article className="rounded-br-lg rounded-bl-lg bg-white-100 transition-all duration-200 ease-linear delay  flex items-center pt-4 pr-1 group-hover:pl-4">
              <div className="flex flex-col w-full">
                <h2 className="font-bold text-left bg-white-100 transition duration-200 ease-linear delay flex items-center justify-between">
                  <div className="text-bodyText origin-left transition-all ease-linear delay truncate-text two-lines">
                    {item?.data?.title}
                  </div>
                  {item?.data?.upcomingEvent && (
                    <div className="py-0 pr-[18px] pl-[5px] opacity-0 transition-all  delay duration-200 ease-linear group-hover:opacity-100">
                      <ClockIcon width={24} height={24} />
                    </div>
                  )}
                </h2>
                <div className="flex justify-between">
                  <div className="flex justify-center flex-col">
                    <p className="flex items-center transition-all duration-200 ease-linear origin-left delay group-hover:scale-90">
                      <LocationIcon />
                      <span className="px-2.5 pb-0.5 text-gray text-sm font-bold">
                        {item?.data?.account?.name}
                      </span>
                    </p>
                    <div className="flex justify-start">
                      <p className="flex items-center transition-all duration-200 ease-linear pb-2.5 origin-left delay group-hover:scale-90">
                        <span className="text-gray text-sm font-bold">
                          {item?.data?.publishingDate && (
                            <>
                              {isLive ? (
                                <span className="flex items-center">
                                  <DateIcon />
                                  <span className="pl-2">
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "dd.MM.yyyy"
                                    )}
                                  </span>
                                </span>
                              ) : (
                                <span className="flex items-center">
                                  <ClockIcon width={11.85} height={11.85} />
                                  <span className="pl-2">
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "HH.mm"
                                    )}
                                  </span>
                                </span>
                              )}
                            </>
                          )}
                        </span>
                      </p>
                      <p className="flex items-center transition-all delay duration-200 ease-linear delay pb-2.5 pl-2 origin-left group-hover:scale-90">
                        <span className="text-gray text-sm font-bold">
                          {item?.data?.publishingDate && (
                            <>
                              {isLive ? (
                                <span className="flex items-center">
                                  <ClockIcon width={11.85} height={11.85} />
                                  <span className="pl-2">
                                    Alkanut:{" "}
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "HH.mm"
                                    )}
                                  </span>
                                </span>
                              ) : (
                                <span className="flex items-center">
                                  <DateIcon />
                                  <span className="pl-2">
                                    {" "}
                                    {format(
                                      new Date(
                                        item?.data?.publishingDate
                                      ).getTime(),
                                      "dd.MM.yyyy"
                                    )}
                                  </span>
                                </span>
                              )}
                            </>
                          )}
                        </span>
                      </p>
                    </div>
                  </div>
                  {isLive ? (
                    <div className="opacity-0 transition-all  delay duration-200 ease-linear group-hover:opacity-100 mr-2">
                      <PlayIcon></PlayIcon>
                    </div>
                  ) : (
                    <div className="rounded bg-blue flex justify-center items-center self-center mr-3 w-9 h-35 opacity-0 transition-all duration-200 ease-linear delay group-hover:opacity-100">
                      <div className="flex justify-center rounded bg-blue self-center text-lg font-bold text-white">
                        <ArrowRight height={10} width={6} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {isLive && <></>}
            </article>
          </div>
        </a>
      </Link>
    </li>
  );
};
export default CarouselItem;
